import { Maybe, ObjectInstance, WorkflowType } from '@/client/services/api/graphql/gql/graphql';

import { useTranslation } from 'react-i18next';

export const useGenerateAutomationInformation = () => {
  const { t } = useTranslation();

  const generateAutomationInformation = (
    type: Exclude<WorkflowType, WorkflowType.PointInTime>,
    trigger: Maybe<ObjectInstance> | undefined,
  ): string => {
    const triggerTranslationMap: Record<Exclude<WorkflowType, WorkflowType.PointInTime>, string> = {
      [WorkflowType.AttendedWorkshop]: `${t(
        'admin.assignments.automationTrigger.attendedWorkshop',
      )} ${trigger?.title} `,
      [WorkflowType.CompletedAssignment]: `${t(
        'admin.assignments.automationTrigger.completedAssignment',
      )} ${trigger?.title} `,
      [WorkflowType.CompletedContent]: `${t(
        'admin.assignments.automationTrigger.completedContent',
      )} ${trigger?.title} `,
      [WorkflowType.Hired_60]: t('admin.assignments.automationTrigger.hired60'),
      [WorkflowType.Hired_90]: t('admin.assignments.automationTrigger.hired90'),
      [WorkflowType.HiredCustom]: t('admin.assignments.automationTrigger.hiredCustom'),
      [WorkflowType.HiredToday]: t('admin.assignments.automationTrigger.hiredToday'),
      [WorkflowType.RegisteredWorkshop]: `${t(
        'admin.assignments.automationTrigger.registeredWorkshop',
      )} ${trigger?.title} `,
      [WorkflowType.UserAdded]: t('admin.assignments.automationTrigger.userAdded'),
      [WorkflowType.UserAddedOrUpdated]: t(
        'admin.assignments.automationTrigger.userAddedOrUpdated',
      ),
      [WorkflowType.UserUpdated]: t('admin.assignments.automationTrigger.userUpdated'),
    };

    return `${t('admin.assignments.automationTrigger.sends')} ${triggerTranslationMap[type]}`;
  };

  return { generateAutomationInformation };
};
